'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlDropdown', function ($document) {
  return {
    restrict: 'A',
    link: function link($scope, $el, $attrs, ctrl) {
      var dropdownId = $attrs.tlDropdown;
      if (dropdownId) {
        $scope.$on("dropdown:" + dropdownId + ":close", function () {
          ctrl.close();
        });
      }
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        opened = false;
      ctrl.isOpened = function () {
        return opened;
      };
      ctrl.toggle = function () {
        opened ? ctrl.close() : ctrl.open();
      };
      ctrl.open = function () {
        if (opened) {
          return;
        }
        _.defer(bindClickHandler); // avoid closing on open by triggering it
        $element.addClass("dropdown-open");
        opened = true;
      };
      ctrl.close = function () {
        if (!opened) {
          return;
        }
        unbindClickHandler();
        $element.removeClass("dropdown-open");
        opened = false;
      };
      var onDocumentClick = function onDocumentClick(e) {
        var parents = $(e.target).parents();
        if (parents.index($element) > -1 && parents.filter("[tl-dropdown-keep-open-on-click]").length > 0) {
          return;
        }
        $scope.$apply(function () {
          ctrl.close();
        });
      };
      var bindClickHandler = function bindClickHandler() {
        $document.bind("click", onDocumentClick);
      };
      var unbindClickHandler = function unbindClickHandler() {
        $document.unbind("click", onDocumentClick);
      };
      $scope.$on("$destroy", function () {
        unbindClickHandler();
      });
    }
  };
});
ngModule.directive('tlDropdownToggle', function () {
  return {
    restrict: 'A',
    require: "^tlDropdown",
    link: function link($scope, $el, $attrs, dropdownCtrl) {
      $el.click(function () {
        $scope.$apply(function () {
          dropdownCtrl.toggle();
        });
      });
    }
  };
});
ngModule.directive('tlDropdownMenu', function ($animate) {
  return {
    restrict: 'A',
    transclude: "element",
    priority: 1000,
    require: "^tlDropdown",
    link: function link($scope, $el, $attrs, dropdownCtrl, transcludeFn) {
      var childScope, previousElements;
      $scope.$watch(function () {
        return dropdownCtrl.isOpened();
      }, function (opened, wasOpened) {
        if (opened === wasOpened) {
          return;
        }
        if (opened) {
          childScope = $scope.$new();
          transcludeFn(childScope, function (clone) {
            $animate.enter(clone, $el.parent(), $el);
            $animate.addClass(clone, "opened");
            previousElements = clone;
          });
        } else {
          if (childScope) {
            childScope.$destroy();
            childScope = null;
          }
          if (previousElements) {
            $animate.removeClass(previousElements, "opened").then(function () {
              previousElements.remove();
              previousElements = null;
            });
          }
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlDropdown.js
// module id = 2899
// module chunks = 13